import { useIntl, FormattedMessage } from 'react-intl';
import Edit from 'src/componentes/edit/edit-dialog';
import Geral from './geral';
import { Schema } from 'src/utils/form';

const schema = Schema.object({
  convenio: Schema.string().required({
    onlyIf: (context) => {
      return (
        context.parent.value.tipoMovimentacaoFinanceira &&
        context.parent.value.tipoMovimentacaoFinanceira.id === 1
      );
    },
  }),

  contrato: Schema.string().required({
    onlyIf: (context) => {
      return (
        context.parent.value.tipoMovimentacaoFinanceira &&
        context.parent.value.tipoMovimentacaoFinanceira.id === 2
      );
    },
  }),

  projeto: Schema.string().required({
    onlyIf: (context) => {
      return (
        context.parent.value.tipoMovimentacaoFinanceira &&
        context.parent.value.tipoMovimentacaoFinanceira.id === 3
      );
    },
  }),

  planoContas: Schema.string(),
  tipoValor: Schema.string().required(),
  entidade: Schema.string(),
  nf: Schema.string(),
  dataPrevista: Schema.string(),
  dataRealizada: Schema.string(),
  valor: Schema.string().required(),
  arquivos: Schema.array().label(<FormattedMessage id="label.anexos" />),
  tipoMovimentacaoFinanceira: Schema.string().required(),
  opcoesTipoMovimentacaoFinanceira: Schema.string(),
});

const EditForm = ({ model }) => {
  return <Geral model={model} />;
};

const EditView = (props) => {
  const intl = useIntl();

  return (
    <Edit
      {...props}
      url="/MovimentacaoFinanceira"
      title={intl.formatMessage({ id: 'movimentacaoFinanceira' })}
      schema={schema}
      formComponent={EditForm}
      width="75%"
      height={500}
      intl={intl}
      showExport={false}
    />
  );
};

export default EditView;
